import { get, includes } from 'lodash-es'
import { getBDCountry } from '@/common/utils/i18n'
import VueI8n from '@/i18n/locale'
const country = getBDCountry() || 'MX'

const INVALID_REASON = {
  // 商机无效原因
  DUPLICATE: 7, // 重复门店
  ELSE: 999, // 其他原因
}
export default {
  required(mask = '', { gettext }, payload) {
    return {
      messages: { required: `${mask} ${gettext('不能为空')}` },
      rules: { required: true },
    }
  },
  max(mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      messages: { max: `${mask}${sprintf(gettext('不能超过%d'), max)}` },
      rules: { max: +max, type: 'number' },
    }
  },

  min(mask = '', { gettext, sprintf }, payload) {
    const [min] = payload
    return {
      messages: { min: `${mask}${sprintf(gettext('不小于%d'), min)}` },
      rules: { min: +min, type: 'number' },
    }
  },

  maxLength(mask = '', { gettext, sprintf }, payload) {
    const [length] = payload
    return {
      messages: { max: `${mask}${sprintf(gettext('不能超过%d字'), length)}` },
      rules: { max: +length },
    }
  },

  minLength(mask = '', { gettext, sprintf }, payload) {
    const [length] = payload
    return {
      messages: { min: `${mask}${sprintf(gettext('不小于%d'), length)}` },
      rules: { min: +length },
    }
  },

  requireLength(mask = '', { gettext, sprintf }, payload) {
    const [length] = payload
    return {
      messages: { len: `${mask}${sprintf(gettext('必须为%d字'), length)}` },
      rules: {
        len: length,
      },
    }
  },

  requireMultyLength(mask = '', { gettext, sprintf }, payload) {
    const [length1, length2] = payload
    return {
      messages: { custom: `${mask}${sprintf(gettext('必须为%d或%d字'), length1, length2)}` },
      rules: {
        custom: value => {
          const length = value.trim().length
          if (length === length1 || length === length2) {
            return true
          } else {
            return false
          }
        },
      },
    }
  },

  multiplePhones(mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    const validator = function (value) {
      const valueArr = value.split(',')
      for (const i of valueArr) {
        if (!/^\d{8,9}$/.test(i)) {
          return false
        }
      }
      return true
    }
    const Lib = {
      COM: {
        rules: {
          custom: value => (value && max ? value.split(',').length <= max : true),
          pattern: /^[0-9,]+$/,
        },
        messages: {
          custom: max ? `${mask}${sprintf(gettext('最多%d个'), max)}` : '',
          pattern: gettext('电话支持字符：数字、英文逗号，录入其他符号，不允许提交'),
        },
      },
      CO: {
        rules: {
          custom: value => (value && max ? value.split(',').length <= max : true),
          pattern: /^[0-9,]+$/,
        },
        messages: {
          custom: max ? `${mask}${sprintf(gettext('最多%d个'), max)}` : '',
          pattern: gettext('电话支持字符：数字、英文逗号，录入其他符号，不允许提交'),
        },
      },
      PE: {
        rules: {
          custom: value => (value && max ? value.split(',').length <= max : true),
          pattern: validator,
        },
        messages: {
          custom: max ? `${mask}${sprintf(gettext('最多%d个'), max)}` : '',
          pattern: gettext('电话支持字符：数字、英文逗号，录入其他符号，不允许提交'),
        },
      },
    }
    return Lib[country] || Lib.COM
  },

  // 结构化多个电话
  structuredPhones(mask = '', { gettext, sprintf }, payload) {
    const validator = function (value) {
      for (const i of value) {
        if (!/^[0-9]{10}$/.test(i.value)) {
          return false
        }
      }
      return true
    }
    return {
      rules: {
        custom: validator,
      },
      messages: {
        custom: gettext('手机和座机都只支持10位数字'),
      },
    }
  },

  postCode(mask = '', { gettext }, payload) {
    return {
      rules: {
        pattern: /^\d+$/,
        custom: value => value.length === 5,
      },
      messages: {
        pattern: `${mask}${gettext('仅支持数字输入')}`,
        custom: gettext('请输入5位有效数字'),
      },
    }
  },

  phone(mask = '', { gettext }, payload) {
    const Lib = {
      COM: {
        messages: {
          pattern: `${mask}${gettext('仅支持数字输入')}`,
          // pattern: `${mask}${gettext('首位必须是1')}`
          // custom: `${mask}${gettext('输入有误')}`
        },
        rules: {
          // custom: value => (value ? value.length : true),
          // pattern: /^1\d{10}$/
          pattern: /^\d+$/,
        },
      },
      DO: {
        messages: {
          pattern: `${mask}${VueI8n.t('FoodB_Launch_Illegal_import_jlOS' /** 输入非法 */)}`,
        },
        rules: {
          pattern: /^(?:809|829|839|849)\d{7}$/,
        },
      },
      CL: {
        messages: {
          pattern: `${mask}${VueI8n.t('FoodB_Launch_Illegal_import_jlOS' /** 输入非法 */)}`,
        },
        rules: {
          pattern: /^\d{9}$/,
        },
      },
      PE: {
        messages: {
          pattern: `${mask}${VueI8n.t('FoodB_Launch_Illegal_import_jlOS' /** 输入非法 */)}`,
        },
        rules: {
          pattern: /^\d{8,9}$/,
        },
      },
    }
    return Lib[country] || Lib.COM
  },

  telePhone(mask = '', { gettext }, payload) {
    const Lib = {
      MX: {
        messages: {
          pattern: `${mask} ${VueI8n.t('FoodB_20250612_GGEs_TCgn' /** 必须输入10位数字 */)}`,
        },
        rules: {
          pattern: /^\d{10}$/,
        },
      },
      BR: {
        messages: {
          pattern: `${mask} ${gettext('输入有误')}`,
        },
        rules: {
          pattern: /^\d{2}9\d{8}$/,
        },
      },
      COM: {
        messages: {
          pattern: `${mask} ${gettext('必须输入8位')}`,
        },
        rules: {
          pattern: /^\d{8}$/,
        },
      },
      CO: {
        messages: {
          pattern: `${mask} ${VueI8n.t('FoodB_20250612_SduQ_XghF' /** 必须输入1-10位数字 */)}`,
        },
        rules: {
          pattern: /^\d{0,10}$/,
        },
      },
      DO: {
        messages: {
          pattern: `${mask} ${VueI8n.t('FoodB_Launch_Illegal_import_jlOS' /** 输入非法 */)}`,
        },
        rules: {
          pattern: /^(?:809|829|839|849)\d{7}$/,
        },
      },
      CL: {
        messages: {
          pattern: `${mask}${VueI8n.t('FoodB_Launch_Illegal_import_jlOS' /** 输入非法 */)}`,
        },
        rules: {
          pattern: /^\d{9}$/,
        },
      },
      PE: {
        messages: {
          pattern: `${mask}${VueI8n.t('FoodB_20250612_nsLy_sirO' /** 必须输入8-9位数字 */)}`,
        },
        rules: {
          pattern: /^\d{8,9}$/,
        },
      },
    }
    return Lib[country] || Lib.COM
  },

  email(mask = '', { gettext }, payload) {
    if (country === 'BR') {
      return {
        rules: {
          // 和后端规则保持一致
          pattern: /^[^@]+@[^@]+$/i,
        },
        messages: {
          pattern: gettext('请输入正确的邮箱地址'),
        },
      }
    } else {
      return {
        rules: {
          pattern: /^[^@]+@[^@\s]+\.[^@\s]+$/i,
        },
        messages: {
          pattern: gettext('请输入正确的邮箱地址'),
        },
      }
    }
  },

  number(mask = '', { gettext }, payload) {
    return {
      rules: {
        type: 'number',
      },
      messages: {
        type: gettext('请输入数字'),
      },
    }
  },
  cardNumber(mask = '', { gettext }, payload) {
    return {
      rules: {
        type: 'number',
        len: 18,
      },
      messages: {
        type: gettext('银行卡号仅支持数字输入'),
        len: gettext('银行卡号必须为18位'),
      },
    }
  },

  specialChars(mask = '', { gettext }, payload) {
    return {
      rules: {
        custom: value => {
          if (!value) return true
          /* eslint-disable */
          return !/[\!\"\#\$\%\/\(\)\=\?\¡\¨\*\[\]\;\:\_\¿\´\+\{\}\,\.\-\>\<\°\|\@\¬\\\~\`\^\ñ\Ñ\á\é\í\ó\ú\Á\É\Í\Ó\Ú\â\ê\î\ô\û\Â\Ê\Î\Ô\Û\ä\ë\ï\ö\ü\Ä\Ë\Ï\Ö\Ü]+/.test(
            value,
          )
        },
      },
      messages: {
        custom: gettext('不允许特殊字符'),
      },
    }
  },

  curpRules(mask = '', { gettext }) {
    return {
      rules: {
        len: 18,
        custom: value => (value ? value.toLocaleUpperCase() === value : true),
      },
      messages: {
        custom: gettext('Curp号必须为大写字母'),
        len: gettext('Curp号必须为18位字符'),
      },
    }
  },
  decimal(mask, { gettext, sprintf }, payload) {
    const [len] = payload
    return {
      rules: {
        type: 'number',
        custom: value => {
          let decimal = (value + '').split('.')[1]
          return decimal ? decimal.length <= len : true
        },
      },
      messages: {
        custom: sprintf(mask + gettext('数值只能是%s位小数'), len),
      },
    }
  },

  openInfo(mask = '', { gettext }, payload) {
    const [tip1] = payload
    return {
      rules: {
        custom: value => {
          if (!value) return true
          /* eslint-disable */
          return value.isNeedPad !== 0 && value.bizDayTime.length > 0
        },
      },
      messages: {
        custom: `${mask}/${tip1}${gettext('不能为空')}`,
      },
    }
  },
  priceInfo(mask = '', { gettext }, payload) {
    return {
      rules: {
        custom: value => {
          if (value.customerPriceRange) {
            return true
          } else {
            return false
          }
        },
      },
      messages: {
        custom: `${mask}${gettext('不能为空')}`,
      },
    }
  },
  cost(mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      rules: {
        type: 'number',
        custom: value => {
          return value ? value <= max : true
        },
      },
      messages: {
        custom: sprintf(mask + gettext('不能超过%d'), max),
      },
    }
  },
  shopId(mask = '', { gettext, sprintf }, payload) {
    return {
      rules: {
        custom: value => {
          return true
        },
        customRequired: value => {
          if (!value) {
            return false
          }
          if (!get(value, 'list.length', null)) {
            return false
          }
          return true
        },
        repeatShopId: value => {
          if (includes(value.list, INVALID_REASON.DUPLICATE) && !value.repeatShopId) {
            return false
          }
          if (
            includes(value.list, INVALID_REASON.DUPLICATE) &&
            !/^[0-9]+$/.test(value.repeatShopId)
          ) {
            return false
          }
          return true
        },
      },
      messages: {
        custom: gettext('您提交的无效原因有误，请检查'),
        customRequired: `${mask}${gettext('不能为空')}`,
      },
    }
  },
  requireValue(mask = '', { gettext }, payload) {
    const [requireValue] = payload
    return {
      rules: {
        custom: value => {
          return value === requireValue
        },
      },
      messages: {
        custom: `${mask}${gettext('需要完善')}`,
      },
    }
  },
  shopIdCascade(mask = '', { gettext }) {
    return {
      rules: {
        custom: value => {
          return !!value
        },
        repeatShopId: value => {
          return !!/^[0-9]+$/.test(value)
        },
      },
      messages: {
        custom: `${mask}${gettext('不能为空')}`,
        repeatShopId: gettext('请输入有效的门店id'),
      },
    }
  },
  CRBankCardRule(mask = '', { gettext }) {
    const Lib = {
      MX: {
        messages: { pattern: `${mask}${sprintf(gettext('输入有误'), 18)}` },
        rules: { pattern: /^(\d{18})$/ },
      },
      CR: {
        messages: {
          // pattern: `${mask}${gettext('仅支持数字输入')}`
          pattern: `${mask} ${gettext('银行卡号为CR开头后面20位数字')}`,
          // custom: `${mask}${gettext('输入有误')}`
        },
        rules: {
          // custom: value => (value ? value.length : true),
          pattern: /^CR\d{20}$/,
          // pattern: /^\d+$/
        },
      },
      CO: {},
      DO: {
        messages: {
          // pattern: `${mask}${gettext('仅支持数字输入')}`
          pattern: `${mask} ${gettext('输入有误')} (7 ~ 17)`,
          // custom: `${mask}${gettext('输入有误')}`
        },
        rules: {
          // custom: value => (value ? value.length : true),
          pattern: /^\d{7,17}$/,
          // pattern: /^\d+$/
        },
      },
      CL: {
        messages: { pattern: `${mask}${sprintf(gettext('不能超过%d'), 45)}` },
        rules: { pattern: /^(\d{1,45})$/ },
      },
      PE: {
        messages: { pattern: `${mask}${sprintf(gettext('输入有误'), 20)}` },
        rules: { pattern: /^(\d{20})$/ },
      },
    }
    return Lib[country] || {}
  },
  RUTRule(mask = '', { gettext }) {
    return {
      rules: {
        /**
         * 【7~8位数字】+【1位校验码】
            校验码为0~9的数字或大写字母“K”
            数字和校验码之间可加“-”，也可以不加
         */
        pattern: /^\d{7,8}-?(\d{1}|K)$/,
      },
      messages: {
        pattern: `${mask} ${gettext('输入有误')}`,
      },
    }
  },
  PElegalId(mask = '', { gettext, sprintf }, payload) {
    const legalType = get(payload, '[0]', '')
    return {
      rules: {
        custom: value => {
          if (+legalType === 9) {
            return /^[0-9]{8,12}$/g.test(value)
          }
          if (+legalType === 13) {
            return /^[0-9a-zA-Z]{8,12}$/g.test(value)
          }
          return !!value
        },
      },
      messages: {
        custom: `${mask}${gettext('输入有误')}`,
      },
    }
  },
  PEbeneficiaryId(mask = '', { gettext, sprintf }, payload) {
    const beneficiaryIdType = payload[0]
    return {
      rules: {
        custom: value => {
          if (+beneficiaryIdType === 27) {
            return /^(\d{8}|\w{9})$/.test(value)
          }
          if (+beneficiaryIdType === 28) {
            return /^\d{11}$/.test(value)
          }
          if (+beneficiaryIdType === 30) {
            return (value + '').length > 4
          }
          return !!value
        },
      },
      messages: {
        custom: `${mask}${gettext('输入有误')}`,
      },
    }
  },
  taxIdRules(mask = '', { gettext }) {
    const validator = function (value) {
      if (!/^([A-Z]|\d){12,13}$/.test(value)) {
        return false
      }
      return true
    }
    return {
      rules: {
        custom: validator,
      },
      messages: {
        custom: VueI8n.t('FoodB_collection_12_or_woYo' /** 输入12-13数字或者字母 */),
      },
    }
  },
  taxIdcifRules(mask = '', { gettext }) {
    const validator = function (value) {
      if (!/^\d{11}$/g.test(value)) {
        return false
      }
      return true
    }
    return {
      rules: {
        custom: validator,
      },
      messages: {
        custom: VueI8n.t('FoodB_collection_11_digits_QhYs' /** 11位数字，不能有空格 */),
      },
    }
  },
  postCodeRules(mask = '', { gettext }) {
    const validator = function (value) {
      if (!/^\d{5,6}$/g.test(value)) {
        return false
      }
      return true
    }
    return {
      rules: {
        custom: validator,
      },
      messages: {
        custom: VueI8n.t('FoodB_collection_5_6_hFrc' /** 5-6位数字 */),
      },
    }
  },
  //巴西
  cnpjRules(mask = '', { gettext }) {
    return {
      rules: {
        // len: 18,
        custom: value => {
          if (!value) return true
          if (value.length !== 18) return false
          return value.length === 18
            ? /^(\d{2})\.(\d{0,3})\.(\d{0,3})\/(\d{0,4})\-(\d{0,2})$/.test(value)
            : true
        },
      },
      messages: {
        custom: gettext('CNPJ号必须为14位数字'),
        // len: gettext('CNPJ号必须为18位数字')
      },
    }
  },
  //巴西
  cpfRules(mask = '', { gettext }) {
    return {
      rules: {
        // len: 14,
        custom: value => {
          if (!value) return true
          if (value.length !== 14) return false
          return value.length === 14
            ? /^(\d{3})\.(\d{0,3})\.(\d{0,3})\-(\d{0,2})$/.test(value)
            : true
        },
      },
      messages: {
        custom: gettext('CPF号必须为11位数字'),
        // len: gettext('CPF号必须为11位数字')
      },
    }
  },
  //巴西
  isBankIOReg() {
    return {
      rules: {
        isBankIOReg: value => {
          return true
        },
      },
      messages: {
        isBankIOReg: '',
      },
    }
  },
}
